export function calcPricePrivate(orbit, carType, amount) {
    // TODO use calculate price from admin
    if (!orbit || !carType) { return 0; }
    let result = 0;
    let KM = orbit.KM, cost = carType.costKM, KMoutBorder = orbit.KMoutBorder, costKMoutBorder = carType.costKMoutBorder;
    result = Math.floor((KM * parseFloat(cost)) + (KMoutBorder * parseFloat(costKMoutBorder)) + getCostBorder(orbit.isBorder, orbit.isCalcBorder, carType.costPassBorder));
    result = result * amount;
    return roundPriceService(result);
}

export function newCalcPricePrivate(orbit, carType, amount) {
    if (!orbit || !carType || !Array.isArray(orbit.orbit.specialPriceRangeDate)) {
        return 0;
    }
    let result = 0;
    const matchingPrice = orbit.orbit.specialPriceRangeDate.find(
        (price) => price.carCode === carType.carCode
    );

    if (matchingPrice && typeof matchingPrice.price === "number") {
        result = matchingPrice.price;
    }

    return roundPriceService(result);
}


const getCostBorder = (isBorder, isCalcBorder, borderCost) => {
    let border = 0;
    if ((isBorder === 'true' || isBorder === true) && isCalcBorder) { 
        border = Number(borderCost);
        border = isNaN(border) ? 0 : border;
    }
    return border;
};

const roundPriceService = (price) => {
    if (typeof price == "number" && price) {
        let splitPrice = price.toString().split("").pop();
        if (splitPrice === undefined) {
            splitPrice = "";
        }
        let lastDigit = parseInt(splitPrice);
        switch (true) {
            case lastDigit < 4:
                price -= lastDigit;
                break;
            case lastDigit < 8:
                price -= lastDigit - 5;
                break;
            case lastDigit >= 8:
                price = price - lastDigit + 10;
                break;
            default:
                break;
        }
    }
    return price;
};

export function calcSadirPrice(orbit, amount){
    if (!orbit) { return 0;}
    return (orbit.price * amount); 
}